module.exports = "f6f1b09b3c5629b4009759d9c0ab4fa6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/platform-mid.png
// module id = 45
// module chunks = 0